"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsRemoteAuthenticatorSettings = void 0;
var _react = _interopRequireWildcard(require("react"));
var _dmsbasereact = require("dmsbasereact");
var _Add = _interopRequireDefault(require("@mui/icons-material/Add"));
var _RemoteType = require("../../constants/RemoteType");
var _Permissions = require("../../constants/Permissions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const DmsRemoteAuthenticatorSettings = () => {
  const table = (0, _react.useRef)(null);
  const [componentMap, setComponentMap] = (0, _react.useState)({});
  (0, _react.useEffect)(() => {
    const fetchComponents = async () => {
      const token = (0, _dmsbasereact.getToken)();
      const response = await (0, _dmsbasereact.fetchData)("/component/all", "GET", token);
      if (response.status === 200) {
        const components = response.data.data || response.data;
        const map = {};
        components.forEach(component => {
          map[component.pk] = component.name;
        });
        setComponentMap(map);
      } else {
        setComponentMap({});
      }
    };
    fetchComponents();
  }, []);
  const header = (0, _react.useMemo)(() => [{
    label: _dmsbasereact.intl.get("Name").d("Name"),
    column_name: "name",
    filter: true
  }, {
    label: _dmsbasereact.intl.get("Type").d("Type"),
    column_name: "auth_type",
    control: "select",
    options: Object.keys(_RemoteType.REMOTE_AUTHENTICATOR_TYPE).reduce((acc, key) => {
      acc[_RemoteType.REMOTE_AUTHENTICATOR_TYPE[key]] = key;
      return acc;
    }, {}),
    map: Object.fromEntries(Object.entries(_RemoteType.REMOTE_AUTHENTICATOR_TYPE).map(_ref => {
      let [key, value] = _ref;
      return [value, key];
    })),
    filter: true
  }, {
    label: _dmsbasereact.intl.get("Componentname").d("Component name"),
    column_name: "component_pk",
    fieldtype: "int",
    control: "select",
    options: componentMap,
    map: componentMap,
    filter: true,
    properties: {
      filter: {
        field: "component_pk"
      }
    }
  }, {
    label: _dmsbasereact.intl.get("Actions").d("Actions"),
    column_name: "actions",
    sortable: false,
    element: row => {
      const name = row.name;
      return /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsButtonGroup, null, /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsTableEditButton, {
        table: table,
        title: _dmsbasereact.intl.get("UpdateAuthenticator", {
          name
        }).d("Update {name}"),
        url: "/authenticators",
        row: row
      }), /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsTableDeleteButton, {
        table: table,
        title: _dmsbasereact.intl.get("DeleteAuthenticator", {
          name
        }).d("Delete {name}"),
        text: _dmsbasereact.intl.get("Authenticator.DeleteButtonMessage", {
          name
        }).d("The authenticator {name} will be deleted. Are you sure?"),
        url: "/authenticators",
        row_pk: row.pk
      }));
    }
  }]);
  const toolbar = /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsFlexContainer, null, /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsFlexContainer.Left, null, /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsPermissions, {
    permissions: _Permissions.Permissions.POLLUX_PERMISSION
  }, /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsTableCreateButton, {
    table: table,
    title: _dmsbasereact.intl.get("CreateAuthenticator").d("Create Authenticator"),
    url: "/authenticators/create",
    header: header
  }))), /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsFlexContainer.Right, null, /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsExport, {
    table: table
  })));
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsTable, {
    ref: table,
    url: "/authenticators/table",
    header: header,
    needs_authentication: true,
    managed: true,
    toolbar: toolbar
  }));
};
exports.DmsRemoteAuthenticatorSettings = DmsRemoteAuthenticatorSettings;